import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MyErrorStateMatcher } from '../login/login.component';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/shared/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: '../login/login.component.scss'
})
export class ChangePasswordComponent {

  isLoading: boolean = false;
  resetForm: any = FormGroup;
  matcher = new MyErrorStateMatcher();
  hidePassword: boolean = true;

  constructor(private formBuilder: FormBuilder, private toast: ToastrService, private dialog: MatDialog, private userService: UserService, private router: Router, private dialogRef: MatDialogRef<ChangePasswordComponent>) {
    this.resetForm = new FormGroup({
      password1: new FormControl("", [Validators.required]),
      password2: new FormControl("", [Validators.required]),
    });
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }

  resetPassword() {
    if (this.resetForm.valid) {
      if (this.resetForm.get('password1').value === this.resetForm.get('password2').value) {
        this.isLoading = true;
        try {
          this.userService.firstUserUpdateUser(this.resetForm.get('password1').value).then((res) => {
            this.toast.success('Password has been changed successfully', '');
            this.isLoading = false;
            this.dialogRef.close();
          });
        } catch (error) {
          this.isLoading = false;
          this.toast.error('Something went wrong, Please try again later!', '');
        }
      } else {
        this.toast.warning('New Password and Confirm Password is not same.', '');
      }
    }
  }
}


